import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/HISTORY/CUSTOMER`;

export const REDUCER_NAME = 'historyCustomerWaybills';

export const LISTING_API = {
  LISTING: `${OPERATIONS_EDGE}/api/shipments`,
};

export const ROUTES = {
  ROOT: '/shipment/track/reference/:reference',
  WAYBILL_ROOT: '/shipment/track/:waybill',
};
